import UbahTemplateLabourCostOnSite from './UbahTemplateLabourCostOnSite';

export default UbahTemplateLabourCostOnSite;
